export default function CountertopsServices() {
  const services = [
    {
      icon: 'ri-hammer-line',
      title: 'Custom Fabrication',
      description: 'Expert fabrication of granite, quartz, and marble countertops tailored to your exact specifications.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Professional Installation',
      description: 'Precise installation by experienced craftsmen ensuring perfect fit and lasting beauty.'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Edge Profiles & Finishes',
      description: 'Wide selection of edge profiles and finishes to match your design preferences.'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Kitchen Countertops',
      description: 'Transform your kitchen with durable, heat-resistant countertops built for daily use.'
    },
    {
      icon: 'ri-drop-line',
      title: 'Bathroom Vanities',
      description: 'Elegant bathroom countertops and vanity tops resistant to moisture and stains.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Countertop Replacement',
      description: 'Complete removal and replacement services for outdated or damaged countertops.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Complete Countertop Services in El Paso
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From selection to installation, our network of countertop contractors provides comprehensive services for residential and commercial projects.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-amber-50 to-white p-8 rounded-xl border border-amber-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-amber-700 text-white rounded-lg mb-6">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
